export const cnhPop = {
  key: 'cnhpop',
  name: 'Programa CNH Popular',
  shortName: 'CNH POP',
  apiKey: 'CNH_POP'
};

export const cnhForAll = {
  key: 'cnhforall',
  name: 'Programa CNH Para Todos',
  shortName: 'CNH Para Todos',
  apiKey: 'CNH_FOR_ALL'
};

export const jovem = {
  key: 'jovem',
  name: 'Jovem Motorista',
  shortName: 'Jovem Motorista',
  apiKey: 'JOVEM_MOTORISTA'
};
